// extracted by mini-css-extract-plugin
export default {"buttons":"ViewsCenter_buttons__Ra8JQ"};